// JS / Helpers / NodeExists

export function ocNodeExists(node) {

  if ( document.body.contains(node) ) {
    return true;

  } else {
    return false;
  }

}
